import { baseApi } from "src/app/apis/baseApi"

import type { ProfileUser } from "./models/MeUser"

export const profileApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProfile: builder.query<ProfileUser, void | null | undefined>({
      query: () => "/api/profile",
      transformResponse: (response: { data: ProfileUser }) => response.data,
    }),
    resetPassword: builder.mutation<{ message: string }, void>({
      query: () => ({
        url: "/api/profile/reset-password",
        method: "POST",
      }),
    }),
    changeUsername: builder.mutation<
      { message: string },
      { currentUsername: string; newUsername: string }
    >({
      query: (body) => ({
        url: "/api/profile/change-username",
        method: "POST",
        body,
      }),
    }),
    // 2FA management (F164)
    get2faStatus: builder.query<
      { data: { enrolled: boolean; factors: any[] } },
      void
    >({
      query: () => "/api/profile/2fa/status",
    }),
    start2faEnroll: builder.mutation<
      { data: { ticketUrl: string; ticketId: string } },
      void
    >({
      query: () => ({
        url: "/api/profile/2fa/enroll",
        method: "POST",
      }),
    }),
    verify2fa: builder.mutation<
      { data: { success: boolean; enrolled: boolean } },
      { code: string }
    >({
      query: (body) => ({
        url: "/api/profile/2fa/verify",
        method: "POST",
        body,
      }),
    }),
    remove2fa: builder.mutation<{ data: { success: boolean } }, void>({
      query: () => ({
        url: "/api/profile/2fa/enroll",
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetProfileQuery,
  useResetPasswordMutation,
  useChangeUsernameMutation,
  useGet2faStatusQuery,
  useStart2faEnrollMutation,
  useVerify2faMutation,
  useRemove2faMutation,
} = profileApi
